export const LETTER_CARDS: { [key: string]: string } = {
  A: '../../images/lettercardA.png',
  B: '../../images/lettercardB.png',
  C: '../../images/lettercardC.png',
  D: '../../images/lettercardD.png',
  E: '../../images/lettercardE.png',
  '1': '../../images/lettercard1.png',
  '2': '../../images/lettercard2.png',
  '3': '../../images/lettercard3.png',
  '4': '../../images/lettercard4.png',
  '5': '../../images/lettercard5.png'
};

export const LETTERS = ['A', 'B', 'C', 'D', 'E'];
export const NUMBERS = ['1', '2', '3', '4', '5'];
export const MAX_SECRET_CODE_WIDTH = 4;
